import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const DrawingEditorUndoV2Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 20 20"
        className="Icon drawing-editor-undo-v-2"
        {...props}
    >
        <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.67}
            d="M4.167 5h6.25a6.25 6.25 0 0 1 0 12.5H7.292m-1.458-15L3.334 5l2.5 2.5"
        />
    </svg>
);
const Memo = memo(DrawingEditorUndoV2Icon);
export default Memo;
